import "../styles/index.css";
import "../scss/main.scss";

import "@hotwired/turbo";
import { Application } from "@hotwired/stimulus";

import { initFlowbite } from "flowbite";

import ModalController from "../controllers/modal_controller";
import VideoModalController from "../controllers/video_modal_controller";
import SwiperController from "../controllers/swiper_controller";
import TestimonialsSwiperController from "../controllers/testimonials_swiper_controller";
import ButtonRippleEffectController from "../controllers/button_ripple_effect_controller";
import SelectDropdownController from "../controllers/select_dropdown_controller";
import RequestInformationFormController from "../controllers/request_information_form_controller";
import PortalsChartController from "../controllers/portals_chart_controller";
import PortalsChartFiveController from "../controllers/portals_chart_five_controller";
import NavigationController from "../controllers/navigation_controller";
import VideoImageAnimationController from "../controllers/video_image_animation_controller";
import TabVideoController from "../controllers/tab_video_controller";
import ApplicantsSwiperController from "../controllers/applicants_swiper_controller";
import TextareaCounterController from "../controllers/textarea_counter_controller";
import NewsBannerController from "../controllers/news_banner_controller";
import ChameleonController from '../controllers/chameleon_controller';
import CookieYesController from "../controllers/cookieyes_controller";
import ListColumnsController from "../controllers/list_columns_controller";


window.Stimulus = Application.start();
window.Stimulus.register("modal", ModalController);
window.Stimulus.register("videoModal", VideoModalController);
window.Stimulus.register("swiper", SwiperController);
window.Stimulus.register("testimonialsSwiper", TestimonialsSwiperController);
window.Stimulus.register("buttonRippleEffect", ButtonRippleEffectController);
window.Stimulus.register("selectDropdown", SelectDropdownController);
window.Stimulus.register("requestInformationForm", RequestInformationFormController);
window.Stimulus.register("portalsChart", PortalsChartController);
window.Stimulus.register("portalsChartFive", PortalsChartFiveController);
window.Stimulus.register("navigation", NavigationController);
window.Stimulus.register("videoImageAnimation", VideoImageAnimationController);
window.Stimulus.register("tabVideo", TabVideoController);
window.Stimulus.register("applicantsSwiper", ApplicantsSwiperController);
window.Stimulus.register("textareaCounter", TextareaCounterController);
window.Stimulus.register("news-banner", NewsBannerController);
window.Stimulus.register("chameleon", ChameleonController);
window.Stimulus.register("cookieyes", CookieYesController);
window.Stimulus.register("listColumns", ListColumnsController);

document.addEventListener('turbo:load', function () {
  initFlowbite();
});
